// extracted by mini-css-extract-plugin
module.exports = {"list_box":"to_do_list_list_box__10VUR"};